// import axiosInstance from "../axios.service"
// import BaseUrl from "../url.service"

// const serverUrl = `${BaseUrl}/attribute`

// // ✅ Add Attribute
// export const addAttributeApi = (formData) => {
//   return axiosInstance.post(`${serverUrl}/addAtt`, formData)
// }

// // ✅ Get All Attributes (with query if needed)
// export const getAttributeApi = (query = "") => {
//   return axiosInstance.get(`${serverUrl}/getAtt?${query}`)
// }

// // ✅ Get Attribute By ID
// export const getAttributeByIdApi = (id) => {
//   return axiosInstance.get(`${serverUrl}/${id}`)
// }

// // ✅ Update Attribute By ID
// export const updateAttributeApi = (id, formData) => {
//   return axiosInstance.put(`${serverUrl}/${id}`, formData)
// }

// // ✅ Delete Attribute By ID
// export const deleteAttributeApi = (id) => {
//   return axiosInstance.delete(`${serverUrl}/${id}`)
// }

// // ✅ Get Unique Keys
// export const getUniqueAttributeKeysApi = () => {
//   return axiosInstance.get(`${serverUrl}/utils/unique-keys`)
// }

// // ✅ Get Attributes By Key
// export const getAttributesByKeyApi = (key) => {
//   return axiosInstance.get(`${serverUrl}/key/${key}`)
// }

// // ✅ Import Attributes (Excel / Bulk)
// export const importAttributesApi = (formData) => {
//   return axiosInstance.post(`${serverUrl}/import`, formData)
// }

// // ✅ Add Key to Attribute
// export const addKeyToAttributeApi = (id, payload) => {
//   return axiosInstance.post(`${serverUrl}/${id}/add-key`, payload)
// }

// // ✅ Remove Key From Attribute
// export const removeKeyFromAttributeApi = (id, payload) => {
//   return axiosInstance.post(`${serverUrl}/${id}/remove-key`, payload)
// }
import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/attribute`

// ✅ Add Attribute
export const addAttributeApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/addAtt`, formData)
}

// ✅ Get All Attributes (supports query params)
export const getAttributeApi = (query = "") => {
  return axiosInstance.get(`${serverUrl}/getAtt?${query}`)
}

// ✅ Get Attribute By ID
export const getAttributeByIdApi = (id) => {
  return axiosInstance.get(`${serverUrl}/${id}`)
}

// ✅ Update Attribute By ID
export const updateAttributeApi = (id, formData) => {
  return axiosInstance.put(`${serverUrl}/${id}`, formData)
}

// ✅ Delete Attribute By ID
export const deleteAttributeApi = (id) => {
  return axiosInstance.delete(`${serverUrl}/${id}`)
}

// ✅ Get Unique Keys
export const getUniqueAttributeKeysApi = () => {
  return axiosInstance.get(`${serverUrl}/utils/unique-keys`)
}

// ✅ Get Attribute values by key
export const getAttributesByKeyApi = (key) => {
  return axiosInstance.get(`${serverUrl}/key/${key}`)
}

// ✅ Import Attributes (CSV / Excel etc.)
export const importAttributesApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/import`, formData)
}

// ✅ Remove specific VALUE from values array
export const removeKeyFromAttributeApi = (id, payload) => {
  return axiosInstance.post(`${serverUrl}/${id}/remove-key`, payload)
}
